import { runIntersectionObserver } from "./components/observer";

import {
  getPromoSwiper, brandSwiper, aboutSwiper
} from "./components/allSwiper";


/* check mobile */
var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const bodyEl = document.body;
if (isMobile) {
  bodyEl.classList.add("mobile");
} else {
  bodyEl.classList.add("desktop");
}

/* home */
const promoSwiper = document.getElementById("promoSwiper");
if (promoSwiper) {
  getPromoSwiper();
}
/*brand*/
const brandSwiperEl = document.getElementById("brandSwiper");
if (brandSwiperEl) {
  brandSwiper();
}

// aboutSwiper();
/* run all  */
runIntersectionObserver();

var bootstrap = require("bootstrap");

var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'))
var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
  return new bootstrap.Dropdown(dropdownToggleEl)
})
/* */

